<template>
  <v-breadcrumbs :items="items" divider=" / ">
    <template v-slot:item="{ item }">
      <router-link v-if="item.to" :to="item.to">{{ item.text }}</router-link>
      <span v-else>{{ item.text }}</span>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'BreadCrumbs',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped></style>
